import { render, staticRenderFns } from "./initData.vue?vue&type=template&id=1421c9c4"
import script from "./initData.vue?vue&type=script&lang=js"
export * from "./initData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports